import candidateApi from './api';

export const getSkills = async () => {
  try {
    const response = await candidateApi.get('/skills');
    return response.data;
  } catch (error) {
    console.error('Error fetching skills:', error);
    throw error;
  }
};

export const updateSkills = async (skillsData) => {
  try {
    const response = await candidateApi.put('/skills', skillsData);
    return response.data;
  } catch (error) {
    console.error('Error updating skills:', error);
    throw error;
  }
};

export const deleteSkill = async (skillName) => {
  try {
    const response = await candidateApi.delete(`/skills/remove/${encodeURIComponent(skillName)}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting skill:', error);
    throw error;
  }
};

export const deleteAllSkills = async () => {
  try {
    const response = await candidateApi.delete('/skills');
    return response.data;
  } catch (error) {
    console.error('Error deleting all skills:', error);
    throw error;
  }
};